import ThailandAutoComplete from 'vue-thailand-address-autocomplete'
import api from '../../services/service_vendor'
import Swal from 'sweetalert2'
// import moment from 'moment'
export default {
  components: {
    ThailandAutoComplete
  },
  data () {
    return {
      title: 'จัดการข้อมูลเจ้าหนี้',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      modal_active: false,
      modal_data: {
        'id': 0,
        'code': '',
        'tax_id': '',
        'name': '',
        'address': '',
        'sub_district': '',
        'district': '',
        'province': '',
        'post_code': '',
        'telephone': '',
        'credit_day': 0,
        'debt_balance': 0,
        'active_status': 0,
        'create_by': '',
        'create_time': '',
        'edit_by': '',
        'edit_time': '',
        'gender_id': null,
        'brith_date': '',
        'facebook': '',
        'line_id': ''
      },
      modal_title: '',
      data_list: [],
      header: {
        'Access-Token': this.$store.state.token
      }
    }
  },
  computed: {
    filterData: function () {
      let text = this.search.trim()
      return this.data_list.filter(Vendortomer => {
        return (
          Vendortomer.name.indexOf(text) > -1 || Vendortomer.code.indexOf(text) > -1
        )
      })
    },
    paginate: function () {
      this.totalItem = this.filterData.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.filterData.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber
    },
    select (address) {
      this.modal_data.sub_district = address.district
      this.modal_data.district = address.amphoe
      this.modal_data.province = address.province
      this.modal_data.post_code = address.zipcode
    },
    close_modal () {
      this.modal_active = false
      this.modal_data = {
        id: 0,
        code: '',
        name: '',
        credit_day: 0,
        debt_balance: 0,
        telephone: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        post_code: '',
        gender_id: null,
        brith_date: '',
        facebook: '',
        line_id: '',
        active_status: 1
      }
    },
    editVendor (data) {
      this.modal_title = 'แก้ไขข้อมูลเจ้าหนี้'
      this.modal_active = true
      this.modal_data = data
    },
    getAll () {
      this.$store.commit('Loading')
      let body = {
        'keyword': '',
        'limit': 1000000,
        'status': 1
      }
      api.listAll(this.REST_URL,
        this.header,
        body,
        result => {
          if (result.response === 'success') {
            this.data_list = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลเจ้าหนี้',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    removeVendor (code) {
      Swal.fire({
        title: 'ลบข้อมูลเจ้าหนี้',
        text: 'ท่านต้องการลบข้อมูลเจ้าหนี้รหัส ' + code + ' ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.$store.commit('Loading')
          var body = {
            'code': code,
            'active_status': 0
          }
          api.removeVendor(this.REST_URL,
            this.header,
            body,
            result => {
              if (result.response === 'success') {
                this.getAll()
                this.$notification['success']({
                  message: 'ลบข้อมูลเจ้าหนี้',
                  description:
                    result.message
                })
              } else {
                this.$notification['warning']({
                  message: 'ดึงข้อมูลเจ้าหนี้',
                  description:
                    result.message
                })
              }
              this.$store.commit('Loading')
            },
            error => {
              alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
            }
          )
        }
      })
    },
    action_modal () {
      if (this.modal_data.code === '') {
        this.addVendor()
      } else {
        this.updateVendor()
      }
    },
    addVendor () {
      this.$store.commit('Loading')
      this.modal_data.credit_day = parseInt(this.modal_data.credit_day)
      this.modal_data.debt_limit = 0
      this.modal_data.debt_balance = parseInt(this.modal_data.debt_balance)
      this.modal_data.active_status = parseInt(this.modal_data.active_status)
      api.AddVendor(this.REST_URL,
        this.header,
        this.modal_data,
        result => {
          if (result.response === 'success') {
            this.getAll()
            this.$notification['success']({
              message: 'เพิ่มข้อมูลเจ้าหนี้',
              description:
                result.message
            })
          } else {
            this.$notification['success']({
              message: 'เพิ่มข้อมูลเจ้าหนี้',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
          this.close_modal()
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    updateVendor () {
      this.$store.commit('Loading')
      this.modal_data.credit_day = parseInt(this.modal_data.credit_day)
      this.modal_data.debt_limit = 0
      this.modal_data.debt_balance = parseInt(this.modal_data.debt_balance)
      this.modal_data.active_status = parseInt(this.modal_data.active_status)
      api.UpdateVendor(this.REST_URL,
        this.header,
        this.modal_data,
        result => {
          if (result.response === 'success') {
            this.getAll()
            this.$notification['success']({
              message: 'บันทึกข้อมูลเจ้าหนี้',
              description:
                result.message
            })
          } else {
            this.$notification['success']({
              message: 'บันทึกข้อมูลเจ้าหนี้',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
          this.close_modal()
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    }
  },
  mounted () {
    this.checkUser()
    this.getAll()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/vendor.js